import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import Menu from './Menu';
import logoINE from '../img/logoINE_blanco.svg';
import logoSIJE from '../img/sijeLogo_PEL2020.svg';

class Encabezado extends Component {
    render() {
        return (
            <div className="header" id="header">
                <div className="container">
                    <div className="row mb-3">
                        <div className="col-md-8 col-sm-8 ocultarPhone">
                            <Link to="./QueEsSIJE">
                                <h1>Centro de Ayuda Portal SIJE 2021</h1>
                            </Link>
                        </div>
                        <div className="col-md-4 col-sm-4 noPadding text-right imgsEncabezado">
                           <a target="_blank" rel="noopener noreferrer">
                                <img src={logoSIJE} alt="Logo SIJE" className="imgBlanca  logoheader"></img>
                            </a>
                            <a href="https://www.ine.mx/" target="_blank" rel="noopener noreferrer">
                                <img src={logoINE} alt="Logo INE"></img>
                            </a>
                        </div>
                        <div className="mostrarPhone">
                            <Link to="./QueEsSIJE">
                                <h1>Centro de Ayuda SIJE 2021</h1>
                            </Link>
                        </div>
                    </div>
                    <Menu />
                </div>
            </div>
        )
    }
}

export default Encabezado;